export default __webpack_public_path__ + "static/media/illustration-work-3-m.aff773df.webp";